
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MansionKind } from "../../../../define/MansionKind";
import UserDataManage from "../../UserDataManage";
import WifeData from "./WifeData";

export default class WifeDataManage {

    wifeData = new WifeData();
 
    loadLocationData() {
        this.wifeData.loadLocalData();
    }

    saveAllLocationData() {
        this.wifeData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {

        let subIntimate = Number(MansionKind.GeneralValue.WIFE_SUB_INTIMATE);
        let bChange = false;
        this.wifeData.lists.forEach((v)=> {
            if (v.intimacy <= 0) {
                return;
            }
            if (v.state != MansionKind.WifeState.WIFE) {
                return;
            }
            bChange = true;
            let intimacy = v.intimacy - subIntimate;
            v.intimacy = Math.max(0, intimacy);
        });
        
        if (bChange) {
            this.wifeData.saveLocalData();
        }
    }

    /** 
     * 数据兼容
     */
    dataCompatibility() {
        // 竹清清
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        if (matchMiaiData.bBridePrice) {
            const wid = MansionKind.GeneralValue.ZHU_QING_QING;
            if (!this.wifeData.isOwnWife(wid, null, false)) {
                let item = this.wifeData.createItem(wid);
                item.state = MansionKind.WifeState.WIFE;
                this.wifeData.saveLocalData();

                UserDataManage.instance.mansionDataManage.mansionDataDispose();
            }
        }
    }

    /**
     * 拥有有效妻子数量
     */
    ownWifeCount() {
        let count = 0;
        this.wifeData.lists.forEach((v)=> {
            if (v.state == MansionKind.WifeState.WIFE) {
                count++;
            }
        });
        return count;
    }

    getIntimateInfo(intimate: number) {
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.WIFE_INTIMACY);
        if (!csvInfos) {
            console.error('未找到wife_intimacy表格数据');
            return null;
        }
        let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfos[i];
            let iMin = info[title.good_min];
            let iMax = info[title.good_max];
            if (intimate < Number(iMin)) {
                continue;
            }

            if (utilsModel.isValidNumberValue(iMax)) {
                if (intimate > Number(iMax)) {
                    continue;
                }
            }
            return CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE_INTIMACY, i);
        }
        return null;
    }

    getWifeInfo(id: string) {
        let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, id);
        if (!csvInfo) {
            console.error(`未找到wife数据 id = `+ id);
            return null;
        }
        return csvInfo;
    }
}
